import { useLocation } from 'react-router-dom';
import { MailFolderId } from '../../../models/Types';

const MAIL_FOLDER_PATH_REGEX = /\/mail\/([^/]+)(?:\/|$)/;

const useMailFolderIdFromPath = (): MailFolderId | null => {
  const { pathname } = useLocation();
  const match = pathname.match(MAIL_FOLDER_PATH_REGEX);
  if (!match) return null;
  const value = match[1];
  if (value === 'null' || value === 'undefined') return null;
  return value;
};

export default useMailFolderIdFromPath;
